module.exports = __webpack_public_path__ + "static/img/team.ecb0fc05.svg";